<template>
  <div class="news" ref="outt">
    <el-row :gutter="24" style="margin:0;">
      <el-col :span="10" :offset="7"  >
         <div class="news-head-table" >
          <li v-for="(item,index) in lis" :key="index" @click="clickLi(item)">
            <span :class="checkid==item.id?'news-head-table-check':''">{{item.text}}</span></li>
         </div>
      </el-col>
    </el-row>

    <el-row :gutter="24" style="margin:0;">
      <el-col :span="14" :offset="5"  >
       <div class="news-box-list">
        <div class="news-box-list-item" v-for="(item,index) in datalist" :key="index" @click="newClick(item)">
          <div class="news-box-list-item-img">
            <img :src="item.thumbnail" alt="">
          </div>
          <div class="news-box-list-item-text">
            <div class="news-box-list-item-text-title">{{item.title}}</div>
            <div class="news-box-list-item-text-text">{{item.intro}}</div>
            <b style="flex:1;"></b>
            <div class="news-box-list-item-text-p"><span>{{item.type==1?'行业新闻':item.type==2?'公司新闻':'热门新闻'}}</span> <b>{{item.time}}</b></div>
          </div>
      </div>
      </div>
      <el-pagination
        style="text-align:center;margin-top:20px;"
        layout="prev, pager, next,total"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="10"
        :total="total">
    </el-pagination>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import lxapi from '../api/api';

export default {
  name: "product",
  data () {
    return {
      checkid:3,
      lis:[
        {text:'最新动态',id:3},
        {text:'行业新闻',id:1},
        {text:'公司新闻',id:2}
      ],
      datalist:[],
      pageNum:1,
      total:0,
    };
  },
  created(){
    this.getlist()
  },
   methods:{
    getlist(){
      var data=this.checkid==3?`?pageNum=${this.pageNum}&pageSize=10`:`?pageNum=${this.pageNum}&pageSize=10&type=${this.checkid}`
      lxapi.getlist(data).then(res=>{
      this.datalist=res.rows
      this.total=res.total
    }).catch(err=>{
      console.log(err)
    })
    },

    clickLi(item){
     this.checkid=item.id
     this.pageNum=1
     this.getlist()
    },

    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        var element=this.$refs.outt
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
        const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
        this.$bus.$emit("clearKeyword",distanceToTop);
        }, 500);
      }

       this.pageNum=val
       this.getlist()

      },
      newClick(item){
        this.$router.push({path:'/new',query:{id:item.id}})
      },

   },
  components: {

  }
};
</script>
<style lang="scss" scoped>
.news{
  .news-head-table{
    height:80px;
    line-height: 80px;
   background: #ffffff;
   color:#676767;
   margin-top:-45px;
   border-radius: 50px 0 50px 0;
   box-shadow:0px 0px 5px 5px #ccc;
   font-size:18px;
   display: flex;
   li{
    flex:1;
    text-align: center;
    .news-head-table-check{
      color:#0152a1;
      padding-bottom:20px;
      border-bottom: 4px solid #0152a1;
    }
    span{
      cursor: pointer;
    }
   }





  }

  .news-box-list{
    .news-box-list-item:hover{
      box-shadow:0px 0px 5px 5px #ccc;

    }
.news-box-list-item{
  cursor: pointer;
 display: flex;
 padding:10px;
 margin-top:50px;
 .news-box-list-item-img{
   width:300px;
   height:250px;
   img{
     width:100%;
     height:100%;
   }
 }
 .news-box-list-item-text{
   flex:1;
   padding-left:40px;
   padding-top:20px;
   padding-right:50px;
   display: flex;
   flex-direction: column;
   .news-box-list-item-text-title{
     font-size:24px;
     display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
   }
   .news-box-list-item-text-text{
     font-size:16px;
     margin-top:10px;
     color:#636363;
     width:100%;
      display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

   }
   .news-box-list-item-text-p{
    display: flex;
      span{
        padding: 5px 10px;
        background: #e3e7ea;
        font-size:12px;
        color:#37383a;
      }
      b{
        color:#979797;
        flex:1;
        text-align: right;
      }
   }
 }
}
}
}
</style>
<style >

.el-pager .number{
  background: white !important;
  border-radius: 0 !important;
}
.el-pager li.active {
  border-radius: 50% !important;
  background: #0152a1 !important;
  color:white !important;
  min-width: 28px !important;
}
</style>
